<template>
  <div class="container map">
    <div class="wraps">
      <div class="center">
        <div class="tops">
          <div class="check">
            <el-checkbox v-model="checked">开启地图模式</el-checkbox>
          </div>
          <div class="map-container" :style="styles">
              <t-map v-if="mapCode=='TX'&&show" ref="map"  :data="resData" :loading.sync="loading"></t-map>
              <t-map1 v-if="mapCode=='GD'&&show" ref="map"  :data="resData" :loading.sync="loading"></t-map1>
          </div>
        </div>
        <div
          class="bots"
          :class="!checked ? 'nopadding' : ''"
        >
          <div class="track" :class="tableData.length == 0 ? 'notrack' : ''">
            <div class="track-table">
              <div class="table">
                <div class="table-empty" v-if="tableData.length == 0&&!loading">
                  <div class="img">
                    <img src="@/assets/images/icon-empty.png" alt />
                  </div>
                  <p>暂无轨迹</p>
                </div>
                <ul>
                  <li
                    :class="index == 0 ? 'active' : ''"
                    v-for="(item, index) in tableData"
                    :key="index"
                  >
                    <div class="track-item" v-if="item.AcceptStation">
                      <div class="track-time">{{ item.AcceptTime }}</div>
                      <div class="track-icon">
                        <i
                          class="iconfont"
                          :class="index == 0 ? 'icondui' : 'iconiconset0422'"
                        ></i>
                      </div>
                      <div class="track-info">
                        <div class="time">{{ item.AcceptTime }}</div>
                        <div class="info">{{ item.AcceptStation }}</div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="copy" v-if="!nocopy">由快递鸟提供技术支持</div>
    </div>
  </div>
</template>

<script>
import tMap from '@/components/map.vue'
import tMap1 from '@/components/map1.vue'
export default {
  props: {},
  components: {
    tMap,
    tMap1
  },
  data() {
    return {
      checked: true,
      show: false,
      loading: false,
      DataSign: "",
      AppKey: process.env.VUE_APP_APPKEY,
      params: {},
      time: 1000 * 60 * 30,
      timer: null,
      form: {
        RequestData: {
          Code:""
        },
        DataSign: "",
        EBusinessID: process.env.VUE_APP_EBUSINESSID,
        RequestType: "8006",
        DataType: "2",
      },
      tableData: [],
      resData: {},
      flag: false,
      nocopy:null,
      query:this.$route.query,
      mapCode:null,
      styles:{}
    };
  },
  created() {
    
  },
  mounted() {
    this.getParams();
    this.setCss();
  },
  computed: {
    
  },
  watch: {
    loading(val) {
      // if (!val) {
      //   document.body.style.overflow = "auto";
      // } else {
      //   document.body.style.overflow = "hidden";
      // }
    },
  },
  methods: {
    setCss(){
      let height=this.$route.query.height;
      if(height){
        if(height.indexOf("px")<0&&height.indexOf("vh")<0){
          if(Number(height)){
            height = Number(height)+"px"
          }
        }
      }
      this.styles={
        height
      }
    },
    getParams() {
      let Code = this.$route.query.code;
      this.nocopy = this.$route.query.nocopy;
      if(!Code){
        this.flag = true;
      }
      this.form.RequestData = {
        Code
      };
      this.getSign();
    },
    getSign() {
      let data = this.$md5(
        JSON.stringify(this.form.RequestData) + this.AppKey
      );
      let res = this.$base64.btoa(data);
      this.form.DataSign = res;
      setTimeout(()=>{
        this.getData()
      },500)
    },
    getData() {
      // document.body.style.overflow = "hidden";
      let data = Object.assign({}, this.form);
      this.loading = true;
      data.RequestData = JSON.stringify(data.RequestData);
      data = this.$qs.stringify(data);
      this.$http(this.$api.exterfaceInvoke, data)
        .then((res) => {
          this.show = true;
          if (res && res.data && res.data.Success) {
            let data = res.data;
            this.resData = data;
            this.mapCode = data.mapCode;
            this.tableData = data.Traces || [];
            this.tableData = this.tableData.reverse();
            this.tableData.forEach(ele=>{
                ele.AcceptTime = this.$tool.formatDate(ele.AcceptTime)
            })
          } else {
            this.loading = false;
            this.show = false;
            this.$message(res.data.Reason)
          }
        })
        .catch(() => {
          this.loading = false;
          this.show = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.center{
    padding-top:0;
    padding-bottom:20px;
}
.copy{
  margin:0;
}
</style>
